import { useNavigate, useParams } from "react-router-dom";
import ModalAmiReport from "./trainingReportToolbarComponent/modalAmiReport";
import { detailTrainingDeleteEvent, detailTrainingReportAmi, detailTrainingReportKmkop } from "../../../config/apiSPA";
import { useState } from "react";
import ReportAmiPDF from "../../../components/pdfGenerator/amiReport/pdfGeneratorAmiTrainingReport";
import ModalKmkopReport from "./trainingReportToolbarComponent/modalKmkopReport";
import KmkopFormater from "../../../components/pdfGenerator/kmkopReport/kmkopFormater";
import KmkopPdf from "../../../components/pdfGenerator/kmkopReport/kmkopPdf";
import ModalConfirm from "../../../components/modal/modalConfirm";
import ModalLoadingPage from "../../../components/modal/loadingPage";
const modalReportAmiInitialState = {
  show: false,
  data: {
    uks: [],
    userName: "",
    mainData: {
      tanggal: "",
      lokasi: "",
      instructor: "",
    },
  },
};
const modalReportKmkopInitialState = {
  show: false,
  data: {
    date: "",
    location: "",
    instructorName: "",
    userName: "",
    ukList: [],
    participantList: [],
  },
};
const modalConfirmInitialState = {
  show: false,
  title: "",
  text: "",
  theme: "",
  id: null,
};
const modalLoadingPageInitialState = {
  show: false,
  text: "",
};
function TrainingReportToolbar() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modalReportAmiState, setModalReportAmiState] = useState(modalReportAmiInitialState);
  const [modalReportKmkopState, setModalReportKmkopState] = useState(modalReportKmkopInitialState);
  const [modalConfirmState, setModalconfirmState] = useState(modalConfirmInitialState);
  const [modalLoadingPageState, setModalLoadingPageState] = useState(modalLoadingPageInitialState);
  const handleClickAmiReport = async () => {
    try {
      const res = await detailTrainingReportAmi(id);
      setModalReportAmiState({
        show: true,
        data: {
          uks: res.data.tel2?.competencies ?? [],
          userName: res.data.userName,
          mainData: {
            tanggal: res.data.startDate,
            lokasi: res.data.locationData.location,
            instructor: res.data.instructorData.namaInstructor,
          },
        },
      });
    } catch (error) {}
  };
  const handleSubmitReportAmi = async (adjustedData) => {
    setModalReportAmiState(modalReportAmiInitialState);
    const selectedUk = adjustedData.ukList.find((a) => a.id === adjustedData.selectedUk);
    if (!selectedUk) {
      console.error("UK tidak ditemukan");
      return;
    }
    const evaluation = selectedUk.evaluation.map((a) => ({
      minepermitNumber: a.participants.manpowerData.minePermitNumber,
      participantName: a.participants.manpowerData.nama,
      company: a.participants.manpowerData.company.name,
      position: a.participants.manpowerData.jabatanFn,
      preTest: a.pre_test,
      postTest: a.post_test,
      practiceTest: a.practice_test,
      result: a.result,
      remark: a.remark,
    }));
    const dataBinding = {
      duration: adjustedData.durasi,
      instructor: adjustedData.instructor,
      title: adjustedData.judul,
      code: adjustedData.kode,
      location: adjustedData.lokasi,
      date: adjustedData.tanggal,
      assessmentDate: adjustedData.tanggalAssessment,
      userName: adjustedData.userName,
      evaluation: evaluation,
    };
    try {
      await ReportAmiPDF(dataBinding);
    } catch (error) {}
  };
  const exportHandleClickKMKOPReport = async () => {
    try {
      const res = await detailTrainingReportKmkop(id);
      setModalReportKmkopState({
        show: true,
        data: {
          date: res.data.startDate,
          location: res.data.locationData.location,
          instructorName: res.data.instructorData.namaInstructor,
          userName: res.data.userName,
          ukList: res.data.tel2?.competencies ?? [],
          participantList: res.data.participants,
        },
      });
    } catch (error) {}
  };
  const handleSubmitReportKmkop = (val) => {
    setModalReportKmkopState(modalReportKmkopInitialState);

    const dataBinding = {
      date: val.date,
      assessmentDate: val.assessmentDate,
      location: val.location,
      instructorName: val.instructorName,
      userName: val.userName,
      selectedParticipant: val.selectedParticipant ?? [],
      participantList: val.participantList.map((item) => ({
        participantId: item.id,
        minepermitNumber: item.manpowerData.minePermitNumber,
        name: item.manpowerData.nama,
        company: item.manpowerData.company.name,
        position: item.manpowerData.jabatanFn,
      })),
      evaluationList: val.ukList.map((item) => ({
        competencyId: item.title.id,
        title: item.title.title,
        participant: item.evaluation.map((i) => ({
          participantId: i.participants.id,
          postTest: i.post_test,
        })),
      })),
    };

    const formater = new KmkopFormater(dataBinding);
    const toPdf = new KmkopPdf(formater.format());
    toPdf.generate();
  };
  const handleClickDeleteEvent = () => {
    setModalconfirmState({
      show: true,
      title: "Warning",
      text: "Are you sure want to delete this training event ?",
      theme: "danger",
      id: id,
    });
  };
  const handleConfirmDeleteEvent = async (e) => {
    setModalconfirmState(modalConfirmInitialState);
    setModalLoadingPageState({
      show: true,
      text: "Deleting event",
    });
    try {
      const res = await detailTrainingDeleteEvent(id);
      navigate(`/training/data`);
    } catch (error) {
    } finally {
      setModalLoadingPageState(modalLoadingPageInitialState);
    }
  };
  return (
    <>
      <div className="mb-md-4 mb-3 d-md-flex gap-3">
        <div className="mt-md-0 mt-2 dropdown-toggle">
          <a href="#/" data-bs-toggle="dropdown" className="text-inverse text-opacity-75 text-decoration-none">
            <i className="fa fa-download fa-fw me-1 text-theme"></i>
            Generate
          </a>
          <div className="dropdown-menu">
            <a onClick={handleClickAmiReport} className="dropdown-item" href="#/">
              AMI Report
            </a>
            <a onClick={exportHandleClickKMKOPReport} className="dropdown-item" href="#/">
              KMKOP Report
            </a>
          </div>
        </div>
        <div className="mt-sm-0 mt-2">
          <a href="#/" onClick={handleClickDeleteEvent} className="text-danger">
            <i className="fa fa-trash fa-fw me-1"></i> Delete
          </a>
        </div>
      </div>
      <ModalLoadingPage show={modalLoadingPageState.show} text={modalLoadingPageState.text} hide={() => setModalLoadingPageState(modalLoadingPageInitialState)} />
      <ModalConfirm
        show={modalConfirmState.show}
        onHide={() => setModalconfirmState(modalConfirmInitialState)}
        title={modalConfirmState.title}
        text={modalConfirmState.text}
        theme={modalConfirmState.theme}
        clicked={handleConfirmDeleteEvent}
      />
      <ModalAmiReport show={modalReportAmiState.show} onHide={() => setModalReportAmiState(modalReportAmiInitialState)} data={modalReportAmiState.data} submitClick={handleSubmitReportAmi} />
      <ModalKmkopReport show={modalReportKmkopState.show} onHide={() => setModalReportKmkopState(modalReportKmkopInitialState)} data={modalReportKmkopState.data} submitClick={handleSubmitReportKmkop} />
    </>
  );
}

export default TrainingReportToolbar;
